import {
  updateUsageRate,
  getUomList,
  getRumList,
  dataByIdUom,
  editUomData,
  updateUomElement,
  createUomElement,
  deleteUnitofMeasurement,
  deleteRUM,
  createRateBalance,
  dataByIdRum,
  getRUMElementTemplate,
  editRUMElementData,
  updateRumElement,
  createRumElement,
  getRUMDropdownTemplate,
  getRUMChargeCodeTemplate,
  getByIdRum,
  getTimeModel,
  getQuantityTire,
  getUsageTemplate,
  getUsageRateTemplate,
  saveTimeModel,
  saveYear,
  savemonths,
  saveDays,
  saveTimes,
  updateYear,
  updatemonths,
  updateDays,
  updateTimes,
  saveMonth,
  getTimePeriodList,
  getTemplateList,
  getViewTemplate,
  createTemplate,
  getTemplateById,
  editTemplate,
  getUsageRatePlanList,
  saveRatePlan,
  getTimemodelList,
  editTimeModel,
  editYear,
  deletetimemodel,
  deletetimemodelyear,
  deletetimemodelmonth,
  deletetimemodelday,
  delateUsageRate,
  deletetimemodeltime,
  deletetimeperiod,
  saveQuantityTier,
  deleteTemplateDefinition,
  viewUsage,
  viewUsageRateBalance,
  updateQuantitytierElement,
} from "@/http/setup/usageRating";

export default {
  namespaced: true,
  state: {
    usageRate: {},
    Uomlist: [],
    Rumlist: [],
    GetTemplate: {},
    ViewTemplate: {},
    CreateTemplate: {},
    TemplateData: {},
    GetTimePeriod: {},
    GetUsageRatePlan: {},
    GetUsageTemplate: {},
    usageRateTemplate: {},
    rateplancreate: "",
    timemodelList: {},
    quantitytier: [],
    quantityTireData: {},
    timeModelList: [],
    viewusagerating: [],
    viewusageratingbalance: [],
    rumTemplate: {},
    rumId: {},
    rumWithTemplate: {},
    uomId: {},
    GetTimePeriod: {},
  },
  actions: {
    async updateUsageRate({ commit }, payload) {
      try {
        const resp = await updateUsageRate(payload.id, payload.data);
        commit("SET_USAGE_RATE", resp);
        return resp;
      } catch (error) {
        throw Error("Something went wrong");
      }
    },
    async setUomList({ commit }, data) {
      const resp = await getUomList();
      commit("SET_UOM", resp.data.pageItems);
      return resp;
    },
    async setRumList({ commit }, data) {
      const resp = await getRumList();
      commit("SET_RUM", resp.data.pageItems);
      return resp;
    },
    async setTemplateList({ commit }) {
      const resp = await getTemplateList();
      commit("SET_TEMPLATE_LIST", resp.data.pageItems);
      return resp;
    },
    async setViewTemplate({ commit }, id) {
      const resp = await getViewTemplate(id);
      commit("SET_VIEW_TEMPLATE", resp.data);
      return resp;
    },
    async createTemplateAction({ commit }, data) {
      const resp = await createTemplate(data);
      commit("CREATE_TEMPLATE_ACTION", resp.data.resourceId);
      return resp;
    },
    async setTemplateById({ commit }, id) {
      const resp = await getTemplateById(id);
      commit("SET_TEMPLATE_BY_ID", resp.data);
      return resp;
    },
    async editTemplateAction({ commit }, data) {
      const resp = await editTemplate(data.id, data.data);
      return resp;
    },

    async createUsageRateBalance({ commit }, data) {
      const resp = await createRateBalance(data);
      return resp;
    },

    async setUsageRatePlanList({ commit }) {
      const resp = await getUsageRatePlanList();
      commit("SET_USAGE_RATE_PLAN_LIST", resp.data.pageItems);
      return resp;
    },

    async setUsageTemplate({ commit }) {
      const resp = await getUsageTemplate();
      commit("SET_USAGE_TEMPLATE", resp.data);
      return resp;
    },
    async setUsageRateTemplate({ commit }) {
      const resp = await getUsageRateTemplate();
      commit("USAGE_RATE_TEMPLATE", resp.data);
      return resp;
    },

    async setviewUsageRateBalance({ commit }, id) {
      const resp = await viewUsageRateBalance(id);
      commit("SET_VIEW_USAGERATEBALANCE", resp.data);
      return resp;
    },
    async setviewUsage({ commit }, id) {
      const resp = await viewUsage(id);
      commit("SET_VIEW_USAGE", resp.data);
      return resp;
    },
    async createRatePlan({ commit }, data) {
      const resp = await saveRatePlan(data);
      commit("CREATE_RATE_PLAN", resp.data.resourceId);
      return resp;
    },
    async createQuantityTier({ commit }, data) {
      const resp = await saveQuantityTier(data);
      commit("CREATE_QUANTITY_TIER", resp.data.resourceId);
      return resp;
    },
    async setTimeModelList({ commit }) {
      const resp = await getTimeModel();
      commit("TIME_MODEL_LIST", resp.data);
      return resp;
    },
    async setTimemodelList({ commit }, id) {
      const resp = await getTimemodelList(id);
      commit("SET_TIMEMODEL_LIST", resp.data);
      return resp;
    },

    async setUsageRatePlanList({ commit }) {
      const resp = await getUsageRatePlanList();
      commit("SET_USAGE_RATE_PLAN_LIST", resp.data.pageItems);
      return resp;
    },
    async setTimeModel({ commit }) {
      const resp = await getTimeModel();
      commit("SET_TEMPLATE_LIST", resp.data);
      return resp;
    },
    async setUsageTemplate({ commit }) {
      const resp = await getUsageTemplate();
      commit("SET_USAGE_TEMPLATE", resp.data);
      return resp;
    },
    async quantityTireAction({ commit }, id) {
      commit("QUANTITY_TIRE", {});
      const resp = await getQuantityTire(id);
      commit("QUANTITY_TIRE", resp.data);
      return resp;
    },
    async deleteTemplateDefinitionAction({ commit }, id) {
      await deleteTemplateDefinition(id);
    },
    async createRumAction({ commit }, payload) {
      const resp = await createRumElement(payload);
      return resp;
    },
    async fetchRUMTemplateAction({ commit }) {
      const resp = await getRUMElementTemplate();
      commit("SET_RUM_TEMPLATE", resp.data);
      return resp;
    },
    async fetchRUMByIdAction({ commit }, id) {
      const resp = await getByIdRum(id);
      commit("SET_RUM_ID", resp.data);
      return resp;
    },
    async getRumWithTemplate({ commit }, id) {
      const resp = await editRUMElementData(id);
      commit("RUM_WITH_TEMPLATE", resp.data);
      return resp;
    },
    async updateRumAction({ commit }, data) {
      const resp = await updateRumElement(data.id, data.data);
      return resp;
    },
    async deleteRUMAction({ commit }, id) {
      await deleteRUM(id);
    },
    async createUomAction({ commit }, payload) {
      const resp = await createUomElement(payload);
      return resp;
    },
    async fetchUomById({ commit }, id) {
      const resp = await editUomData(id);
      commit("UOM_BY_ID", resp.data);
      return resp;
    },
    async updateUomAction({ commit }, data) {
      const resp = await updateUomElement(data.id, data.data);
      return resp;
    },
    async deleteUnitofMeasurementAction({ commit }, id) {
      await deleteUnitofMeasurement(id);
    },
    async saveTimeModelAction({ commit }, data) {
      const resp = await saveTimeModel(data);
      return resp;
    },
    async saveYearAction({ commit }, data) {
      const resp = await saveYear(data);
      return resp;
    },
    async savemonthsAction({ commit }, data) {
      const resp = await savemonths(data);
      return resp;
    },
    async saveDaysAction({ commit }, data) {
      const resp = await saveDays(data);
      return resp;
    },
    async saveTimesAction({ commit }, data) {
      const resp = await saveTimes(data);
      return resp;
    },
    async editTimeModelAction({ commit }, data) {
      const resp = await editTimeModel(data.id, data.data);
      return resp;
    },
    async updateYearAction({ commit }, data) {
      const resp = await updateYear(data.id, data.data);
      return resp;
    },
    async updatemonthsAction({ commit }, data) {
      const resp = await updatemonths(data.id, data.data);
      return resp;
    },
    async updateDaysAction({ commit }, data) {
      const resp = await updateDays(data.id, data.data);
      return resp;
    },
    async updateTimesAction({ commit }, data) {
      const resp = await updateTimes(data.id, data.data);
      return resp;
    },
    async deletetimemodelAction({ commit }, id) {
      await deletetimemodel(id);
    },
    async deletetimemodelyearAction({ commit }, id) {
      await deletetimemodelyear(id);
    },
    async deletetimemodelmonthAction({ commit }, id) {
      await deletetimemodelmonth(id);
    },
    async deletetimemodeldayAction({ commit }, id) {
      await deletetimemodelday(id);
    },
    async delateUsageRateAction({ commit }, id) {
      await delateUsageRate(id);
    },
    async deletetimemodeltimeAction({ commit }, id) {
      await deletetimemodeltime(id);
    },
    async setTimePeriodList({ commit }) {
      const resp = await getTimePeriodList();
      commit(types.SET_TIME_PERIOD_LIST, resp.data.pageItems);
      return resp;
    },
    async updateQuantitytierElement({ commit }, id , payload) {
      const resp = await updateQuantitytierElement(id, payload);
      return resp;
    },
  },
  mutations: {
    ["SET_USAGE_RATE"](state, payload) {
      Object.assign(state, { usageRate: payload });
    },
    ["SET_UOM"](state, payload) {
      Object.assign(state, { Uomlist: payload });
    },
    ["SET_RUM"](state, payload) {
      Object.assign(state, { Rumlist: payload });
    },

    ["SET_TIME_PERIOD_LIST"](state, payload) {
      Object.assign(state, { GetTimePeriod: payload });
    },
    ["SET_TEMPLATE_LIST"](state, payload) {
      Object.assign(state, { GetTemplate: payload });
    },
    ["SET_VIEW_TEMPLATE"](state, payload) {
      Object.assign(state, { ViewTemplate: payload });
    },
    ["CREATE_TEMPLATE_ACTION"](state, payload) {
      Object.assign(state, { CreateTemplate: payload });
    },
    ["SET_TEMPLATE_BY_ID"](state, payload) {
      Object.assign(state, { TemplateData: payload });
    },
    ["SET_USAGE_RATE"](state, payload) {
      Object.assign(state, { usageRate: payload });
    },
    ["SET_USAGE_RATE_PLAN_LIST"](state, payload) {
      Object.assign(state, { GetUsageRatePlan: payload });
    },
    ["SET_USAGE_TEMPLATE"](state, payload) {
      Object.assign(state, { GetUsageTemplate: payload });
    },
    ["USAGE_RATE_TEMPLATE"](state, payload) {
      Object.assign(state, { usageRateTemplate: payload });
    },
    ["CREATE_RATE_PLAN"](state, payload) {
      Object.assign(state, { rateplancreate: payload });
    },
    ["SET_TIMEMODEL_LIST"](state, payload) {
      Object.assign(state, { timemodelList: payload });
    },
    ["CREATE_QUANTITY_TIER"](state, payload) {
      Object.assign(state, { quantitytier: payload });
    },
    ["TIME_MODEL_LIST"](state, payload) {
      Object.assign(state, { timeModelList: payload });
    },
    ["SET_VIEW_USAGE"](state, payload) {
      Object.assign(state, { viewusagerating: payload });
    },
    ["SET_VIEW_USAGERATEBALANCE"](state, payload) {
      Object.assign(state, { viewusageratingbalance: payload });
    },
    ["QUANTITY_TIRE"](state, payload) {
      Object.assign(state, { quantityTireData: payload });
    },
    ["SET_RUM_TEMPLATE"](state, payload) {
      Object.assign(state, { rumTemplate: payload });
    },
    ["SET_RUM_ID"](state, payload) {
      Object.assign(state, { rumId: payload });
    },
    ["RUM_WITH_TEMPLATE"](state, payload) {
      Object.assign(state, { rumWithTemplate: payload });
    },
    ["UOM_BY_ID"](state, payload) {
      Object.assign(state, { uomId: payload });
    },
    ["SET_TIME_PERIOD_LIST"](state, payload) {
      Object.assign(state, { GetTimePeriod: payload });
    },
  },
};
